import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

const sliceName = "india";
export const fetchStats = createAsyncThunk(
  `${sliceName}/fetchStats`,
  async () => {
    const res = await fetch(
      "https://api.apify.com/v2/key-value-stores/toDWvRj1JpTXiM8FF/records/LATEST"
    );
    const data = await res.json();
    return data;
  }
);
export const indiaSlice = createSlice({
  name: sliceName,
  initialState: {
    regionData: [],
    activeCases: "",
    recovered: "",
    deaths: "",
    isLoading: false,
    error: "",
  },
  reducers: {},
  extraReducers: {
    [fetchStats.pending]: (state, action) => {
      state.error = null;
      state.isLoading = true;
    },
    [fetchStats.fulfilled]: (state, action) => {
      state.error = null;
      state.isLoading = false;
      state.activeCases = action.payload.activeCases;
      state.recovered = action.payload.recovered;
      state.deaths = action.payload.deaths;
      state.regionData = action.payload.regionData;
    },
    [fetchStats.rejected]: (state, action) => {
      state.isLoading = false;
      state.error = "Sorry no data available, please try later";
    },
  },
});
export const { actions, reducer } = indiaSlice;
export default reducer;
export const selectIndiaStats = (state) => state.indiaStats;
